import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useDispatch, useSelector } from 'react-redux'
import { appTheme } from '../../../../../../helpers/utils/Utils';
import schSucess from '../../../../../../assets/smi-kudzu-images/sch_success.png'
import RemoveBillere from '../../../../../../assets/smi-kudzu-images/remove_biller.png'
const RemoveBiller = ({ isSubErrMsg, ModalClose , btnOne , btnTwo , showSubHeading}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);

    const handleOk = () => {
        ModalClose(false)
        navigate('/home');
    }
    return (
        <div className=' flex flex-col justify-start items-start w-full'>
            {!showSubHeading && 
                   <p className={`font-hanken-grotesk font-[400] sm:font-[500] ${kudzuPlusTrue ? "text-white" : ""}
                leading-[24px] lg:text-[16px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[22px] md:leading-[28px]
                 text-secondary-3`}>{t("REMOVE_BILLER_SUB_HEADING")}</p>
            }
         

            <div className="w-full flex justify-center">
            {kudzuPlusTrue ? (
            <img src={RemoveBillere} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />

            ) :(
            <img src={RemoveBillere} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />

            )}

            </div>

            <div className=' flex flex-col gap-4 justify-center items-center w-full mb-20'>
                <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={btnOne}>  {showSubHeading ?  t("Yes, Delete") : t("Yes, Remove")}</button>
                <button className='focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[] text-[#2965FB] cursor-pointer  px-2 py-4 border-[#4B70B9] w-full' onClick={btnTwo}>{t("Cancel")}</button>
            </div>
        </div>
    )
}
export default withOidcSecure(RemoveBiller)